import { isUnAuthorizedError, unAuthorizedErrorHandler } from 'common/ApiWrapper'
import { isAvMed } from 'context';

export const TilesIds = {
  findDoctor: 'FindaDoctor',
  viewClaims: 'MedicalClaimsandExplanations',
  ViewIDCard: 'MemberIDCard',
  BenefitsSnapshot: 'Benefits',
  MyProfile: 'MyProfile',
  UrgentCareSearch: 'UrgentCare',
  ContactUs: 'ContactUs',
  MyPlan: 'YourPlan',
  FormsAndDocuments: 'FormsandDocuments',
  VirtualVisit: 'MDLIVEVirtualVisit',
  PayMonthlyPremium: 'PayMonthlyPremium',
  HealthReimbursementAccount: 'ManageHealthReimbursementAccount',
  HealthSavingsAccount: 'ManageHealthSavingsAccount',
  Authorizations: 'Authorizations',
  SmartShopper: 'SmartShopper',
  CalculateTreatmentCosts: 'CalculateTreatmentCosts',
  RxSavings: 'RxSavings',
};

export const dateformat = {
  dateFormatMDY: 'MM/DD/YYYY',
  isodateFormatMDY: 'MM/dd/yyyy',
  dateFormatISO: 'yyyy-MM-dd',
  dateFormatHypen: 'MM-dd-yyyy',
  dayMonth: 'MM/DD/',
};

export const MyPlanTabs = {
  overviewTabs: 'overview_tabs',
  memberDetailsTabs: 'member_details_tabs',
  designatedTabs: 'designated_representative_tabs',
  profileDob: 'profileDob',
  overViewID: '1',
  memberDetailID: '2',
  designatedID: '3',
};

export const profileTabs = {
  profileDetailsTab: 'profile-details',
  setMyPreferenceTab: 'acc-settings',
  profileDetailsID: '1',
  setMyPreferenceID: '2',
};

export const UserDetails = {
  guest: 'guest',
  personId: 'personId',
  firstName: 'firstName',
  lastName: 'lastName',
  emailId: 'emailId',
  usedId: 'usedId',
  memberIdHistory: 'memberIdHistory',
  serviceNumber: 'ServiceNumber',
  preferenceDepedent: 'preferenceDepedent',
  memberId: 'memberId',
  inActiveSignOut: 'inActiveSignOut',
  optimaPersonCookie: 'OptimaPersonCookie',
  optimaRoleCookie: 'OptimaRoleCookie',
  authToken: 'authToken',
  bearerToken: 'BearerToken',
  id: 'id',
  mId: 'mId',
  proxyId: 'proxyId',
  key: 'key',
  proxyMemberId: 'proxyMemberId',
  memberIdData: 'memberIdData',
  claimsId: 'claimsId',
  claimsType: 'claimsType',
  memberSuffix: 'memberSuffix',
  registerId: 'registerId',
  sessionMeta: 'sessionMeta',
};

export const Proxy = {
  MemberId: 'MemberId',
  DesignatedRepresentative: 'DesignatedRepresentative',
  DesignatedDropdownLink: 'DesignatedDropdownLink',
  memberProxy: 'memberProxy',
  updateFeature: 'updateFeature',
};

export const RequestStatus = {
  status401: 'Request failed with status code 401',
  status440: 'Request failed with status code 440',
};

export const getMemberPlan = {
  dependents: 'dependents',
  planName: 'planName',
};

export const getPlanType = {
  medicare: 'Medicare',
  medicaid: 'Medicaid',
  individual: 'individual'
}

export const getMaxLength = {
  employeeAccessCode: 20,
  ssn: 4,
  guestSSN: 9,
  memberId: 20,
  medicare: 50,
  userName: 20,
  firstName: 50,
  lastName: 50,
  email: 100,
  name: 30,
  password: 64,
  phoneNumber: 12,
  maxPhoneNumber: 10,
  zipCode: 5,
  dob: 10,
  date: 10,
  textArea: 500,
};

export const REGISTRATION_STEP_ONE = 0;
export const GUEST_REGISTRATION_STEP_ONE = 1;


export const errorhandler = (error) => {
  if (isUnAuthorizedError(error)) {
    unAuthorizedErrorHandler()
  }
};

export const REQUEST = 'request';

export const ProfileUpdate = 'profileUpdate';
export const SHOW_PREFERENCE_POPUP = 'showPreferencePopup';

export const DOMAIN_SHP = '.sentarahealthplans.com';
export const DOMAIN_AVMED = '.avmed.com';

export const backToDashboardLink = 'backToDashboardLink';
export const MemberProxyData = 'MemberProxyData';

export const userAddressTypeHome = 'HOME';
export const SERVICE_PHONE_NUMBER = "1-800-394-2237"
export const CARE_COORDINATOR_PHONE_NUMBER = '1-866-546-7924';
export const SERVICE_PHONE_NUMBER_BEHAVIORAL_HEALTH = "1-833-717-2310"
export const NURSE_ADVICE_LINE_MEDICAID_OR_DSNP_PHONE_NUMBER = '1-833-933-0487';
export const sessionIdleTime = 900;
export const MINIMIZE_TIMEOUT = 15000;
export const API_STATUS_SUCCESS = '200';
export const claimsDefaultDate = 18;
export const month = 'month';
export const internalServerErrorCode = '500';
export const userLockedOut = "User Locked Out.";
export const kbaFailureError = "kba verification failure";
export const sessionTimedOut = "Session has timed out"
export const API_STATUS_CONFLICT = 409;
export const preferencesDetails = {
  English: 'English',
  Spanish: 'Spanish',
  ExplanationOfBenefits: 'Explanation of Benefits',
  SummaryOfBenefits: 'Summary of Benefits and Coverage',
  OtherDocuments: 'Other Documents',
};

export const featureToggleConstants = {
  accountDeletion: 'AccountDeletion',
  accountSettings: 'AccountSettings',
  allowParentViewClaims: 'AllowParentViewClaims',
  allowspouseviewclaims: 'Allowspouseviewclaims',
  appreviewPrompt: 'AppreviewPrompt',
  authorizations: 'Authorizations',
  behavioralClaims: 'BehavioralClaims',
  behavioralHealthProvider: 'BehavioralHealthProvider',
  behavioralHealthSearch: 'BehavioralHealthSearch',
  benefits: 'Benefits',
  benefitsCoverage: 'BenefitsCoverage',
  careATC: 'CareATC',
  changePCP: 'ChangePCP',
  contactUs: 'ContactUs',
  contactusSalesForce: 'ContactusSalesForce',
  coveredEligibleMembers: 'CoveredEligibleMembers',
  OrderMemberIDCard: 'OrderMemberIDCard',
  DentaQuest: 'DentaQuest',
  designatedRepresentativeTab: 'DesignatedRepresentativeTab',
  childOnlyPlan: 'ChildOnlyPlan',
  doctorAndMedications: 'DoctorAndMedications',
  doctorSearch: 'DoctorSearch',
  documentDeliveryPreferences: 'DocumentDeliveryPreferences',
  emergencyTravelAssistance: 'EmergencyTravelAssistance',
  enrollInBenefits: 'EnrollInBenefits',
  eob: 'Eob',
  estimateTreatmentCosts: 'EstimateTreatmentCosts',
  findADoctor: 'FindADoctor',
  findCare: 'FindCare',
  findDoctorsOrProviders: 'FindDoctorsOrProviders',
  fitness: 'fitness',
  forgeRockSecurityQuestionandAnswer: 'ForgeRockSecurityQuestionandAnswer',
  formerAvmedMembers: 'FormerAvmedMembers',
  formsandDocuments: 'FormsandDocuments',
  formulary: 'Formulary',
  frequentlyAskedQuestions: 'FrequentlyAskedQuestions',
  getHealthy: 'GetHealthy',
  hSQEstimateTreatmentCosts: 'HSQEstimateTreatmentCosts',
  healthSparqOneCostCalculator: 'HealthSparqOneCostCalculator',
  homeTiles: 'HomeTiles',
  hospitalFacilityAndOtherServices: 'HospitalFacilityAndOtherServices',
  iBMEstimateTreatmentCosts: 'IBMEstimateTreatmentCosts',
  jivaCarePlan: 'JivaCarePlan',
  liveChat: 'LiveChat',
  loginScreenDisable: 'LoginScreenDisable',
  mDLiveVirtualVisit: 'MDLiveVirtualVisit',
  manageHSA: 'ManageHSA',
  manageHealthReimbursementAccount: 'ManageHealthReimbursementAccount',
  manageorRenewPolicy: 'ManageorRenewPolicy',
  medicalClaims: 'MedicalClaims',
  memberRegistration: 'MemberRegistration',
  memberServicesNumbers: 'MemberServicesNumbers',
  memberidCard: 'MemberidCard',
  myProfile: 'MyProfile',
  memberAccount: 'MemberAccount',
  memberProfile: 'MemberProfile',
  mpcInRegistration: 'MpcInRegistration',
  niceIncontact: 'NiceIncontact',
  omniChannelLiveChat: 'OmniChannelLiveChat',
  orderMemberIDCard: 'OrderMemberIDCard',
  payMonthlyPremium: 'PayMonthlyPremium',
  paymentsBillingAndClaims: 'PaymentsBillingAndClaims',
  personalHealthAssessment: 'PersonalHealthAssessment',
  personalHealthRecord: 'PersonalHealthRecord',
  pharmacyBenefitsManager: 'PharmacyBenefitsManager',
  pharmacyClaims: 'PharmacyClaims',
  pharmacyResources: 'PharmacyResources',
  pharmacySearch: 'PharmacySearch',
  planDocuments: 'PlanDocuments',
  planList: 'PlanList',
  prescriptionDrugs: 'PrescriptionDrugs',
  prodSSLCert: 'ProdSSLCert',
  profilePCP: 'ProfilePCP',
  rxSavings: 'RxSavings',
  scheduleLabWork: 'ScheduleLabWork',
  smartShopper: 'SmartShopper',
  sMGProvider: 'SMGProvider',
  sSLCert_v: 'SSLCert-v',
  testiOS: 'TestiOS',
  updateEmailPrompt: 'UpdateEmailPrompt',
  urgentCareSearch: 'UrgentCareSearch',
  viewAnnualDeductiblesandMaximums: 'ViewAnnualDeductiblesandMaximums',
  viewCarePlan: 'ViewCarePlan',
  viewClaims: 'ViewClaims',
  viewIDCard: 'ViewIDCard',
  viewTaxYearSummary: 'ViewTaxYearSummary',
  visionCare: 'VisionCare',
  visionTest: 'VisionTest',
  virtualFirstHealthPlan: 'VirtualFirstHealthPlan',
  wellnessTools: 'WellnessTools',
  yourPlan: 'YourPlan',
  faxIDCard: 'faxIDCard',
  newIDCardFlow: 'newIDCardFlow',
  printIDCard: 'printIDCard',
  shareIDCard: 'shareIDCard',
  textNotifications: 'TextNotifications',
  languagePreference: 'LanguagePreference',
  // For not logged in user
  optimaHealth: 'Optima Health',
  members: 'Members',
  providers: 'Providers',
  employers: 'Employers',
  brokers: 'Brokers',
  VirtualVisitEAP: 'VirtualVisitEAP',
  MaintenanceBanner: 'MaintenanceBanner',
  MaintenancePage: 'MaintenancePage',
  ProfileImageEdit: "ProfileImageEdit",
  FAQs: 'FAQs',
};

export const FormTitles = isAvMed() ? [
  'Personal Information',
  'Account Setup',
  'Communication Preferences',
  '',
] : [
  'Get Started',
  'Personal Information',
  'Account Setup',
  'Communication Preferences',
  '',
];

// Translation key mappings for FormTitles
/** @type {{ [key: string]: string }} */
export const FormTitleTranslationKeys = {
  'Get Started': 'common.registrationGetStarted',
  'Personal Information': 'common.registrationPersonalInformation',
  'Email Verification': 'common.registrationEmailVerification',
  'Username & Password': 'common.registrationUsernamePassword',
  'Account Setup': 'activation.accountSetup',
  'Security Questions': 'common.registrationSecurityQuestions',
  'Communication Preferences': 'common.registrationCommunicationPreferences',
};

export const proxyViewFeatureList = [
  featureToggleConstants.accountDeletion,
  featureToggleConstants.accountSettings,
  featureToggleConstants.benefitsCoverage,
  featureToggleConstants.formsandDocuments,
  featureToggleConstants.myProfile,
  featureToggleConstants.changePCP,
  featureToggleConstants.contactUs,
  featureToggleConstants.documentDeliveryPreferences,
  featureToggleConstants.homeTiles,
];

const AVMED_CONST = {
  minAge: (value) => value ? 13 : 0,
}

const SENTARA_CONST = {
  minAge: (value) => value ? 14 : 0,
}

export const retrieveBrandConst = (isAvMed = false) => {
  return isAvMed ? AVMED_CONST : SENTARA_CONST
}

export const WELLNESS_PLAN_CONST = 'Wellness';

export const PROXY_EXPIRED_URL = '/proxy-expired-form';
export const PROXY_REGISTER_URL = '/proxy-register';
export const PROXY_AUTHORIZATION_ERROR_URL = '/proxy-authorization-error';
export const AUTH_SUCCESS_URL = '/iam-authentication-success';
export const FITNESS_PATH = '/fitness/';
export const FITNESS_MAP_URL = {
  FitnessFfm: `${FITNESS_PATH}IFP`,
  FitnessIndIfp: `${FITNESS_PATH}IFP`,
  FitnessSg: `${FITNESS_PATH}SG`,
  FitnessLgs: `${FITNESS_PATH}LG`,
  FitnessLgf: `${FITNESS_PATH}LG`,
  FitnessMewa: `${FITNESS_PATH}SG`,
  FitnessMdc: `${FITNESS_PATH}MDC`,
  FitnessJhs: `${FITNESS_PATH}JHS`
};

export const planTypeDropDown = {
  data: [
    { planId: "0", planName: "Medicare" },
    { planId: "1", planName: "Medicaid" },
    { planId: "2", planName: "Employer Group/Individual Product" },
    { planId: "3", planName: "I don’t know" }
  ]
};

export const medicalClaimsConstants = {
  memberId: '/member/memberId',
  payToProviderName: 'payToProviderName',
  practiceName: 'practiceName',
  inNetwork: 'inNetwork',
  totalCoinsurance: 'totalCoinsurance',
  totalCopay: 'totalCopay',
  totalPatientResponsibility: 'totalPatientResponsibility',
  totalPaidByPlan: 'totalPaidByPlan',
  totalCovered: 'totalCovered',
  totalNotCovered: 'totalNotCovered',
  totalDeductible: 'totalDeductible',
  totalCharges: 'totalCharges',
  itemServiceType: 'itemServiceType',
  note: 'note',
  typeAheadSearchLimit: 3,
}

export const contactUSQuestionTypes = [
  "Provider Question",
  "ID Card",
  "Medical Benefit/Claim",
  "Enrollment",
  "Behavioral Health Benefit/Claim",
  "Pharmacy",
  "Dental/Vision Benefit",
  "Web Site Assistance",
  "Concern/Complaint",
  "Other"
];


export const contactUSOptions = [
  "Phone",
  "Email",
  "Mail"
];

// Dashboard tiles configuration for brands
export const DASHBOARD_TILES = [
  'MemberIDCard',
  'MyProfile',
  'PayMonthlyPremium',
  'MDLIVEVirtualVisit',
  'FindaDoctor',
  'RxSavings',
  'CalculateTreatmentCosts',
  'SmartShopper',
  'Benefits',
];
